import { render } from "./PasswordResetView.vue?vue&type=template&id=50143284"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__